import { render } from "./VHeader.vue?vue&type=template&id=a1abc334"
import script from "./VHeader.vue?vue&type=script&lang=js"
export * from "./VHeader.vue?vue&type=script&lang=js"

import "./VHeader.vue?vue&type=style&index=0&id=a1abc334&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__